// extracted by mini-css-extract-plugin
module.exports = {"pager":"pager__2yX7M","page-item":"page-item__14bOE","active":"active__S6nxD","body":"body__2IhO2","counter":"counter__2Umrc"};